import $ from 'jquery';
import ko from 'lib/knockout';
import numeral from 'lib/numeral';
import * as _ from 'lib/underscore';
import * as nav from './navigator';
import {newLogger} from '../../../core/utils/logger';
import 'lib/rangeslider';
import * as urlUtils from "../../../core/utils/url";
import {Settings} from "../common/model/settings";
import {List, ListItem} from "../common/model/lists";
import {CategoryItem, CategoryList, PopularShopItem, SubcategoryItem} from "../common/model/categories";
import {ProductItem, ProductList} from "../common/model/products";
import * as langUtils from "../../../core/utils/lang";
import {element} from "../../../core/utils/var";
import {shopData, settings, debugInfo} from "../common/data";
import {Notifier} from "../../../core/widgets/notifier";
import loading from "../../../core/widgets/loading";
import {lang} from "../../../core/utils/lang";
import {MODAL_SELECT_SHOP_CATEGORY} from "../../../core/modals"

const logger = newLogger('Catalog');

window.nav = nav;

/**
 *
 * @param {object} options
 * @return {CatalogViewModel}
 */
export function init(options) {
	logger.log('init', options);
	const model = new CatalogViewModel(settings);
	model.init(options);
	window.catalogModel = model;
	return model;
}

class CatalogViewModel {
	pageData = new PageData();

	ready = ko.observable(false);
	loading = ko.observable(false);
	error = ko.observable(false);
	initialized = ko.observable(false);

	/** @type {Settings} */
	settings = null;
	sidebar = new Sidebar();
	viewOptions = new ViewOptions();
	selection = new SelectionList();
	/** @type {CProductList} */
	products = null;

	constructor(settings) {
		this.settings = settings;
		this.products = new CProductList(settings, this.sidebar);
		this.adminPanel = new AdminPanel(this.products);
	}

	get selectedCategory() {
		return this.sidebar.selectedCategory;
	}

	get selectedSubcategory() {
		return this.sidebar.selectedSubcategory;
	}

	init(options) {
		const o = {
			meta: {},
			products: [],
			productsScores: {},
			favorites: [],
			...options
		};

		nav.init(this.settings.shopUrl, this.settings.catalogApiUrl);
		nav.loader.onStart(() => {
			this.loading(true);
		});
		nav.loader.onStop((success) => {
			this.loading(false);
			this.error(!success);
		});
		nav.loader.onResponse((data) => {
			this._updateServerDataWhenReady(data);
		});

		if (shopData) {
			this.sidebar.initData(shopData);
		}
		if (o.meta) {
			this._initMeta(o.meta);
		}
		this.pageData.init();

		this._initProducts(o);

		this.initialized(true);
		this.ready(true);

		this._initScrollTop();

		// fill debug info
		const searchCriteria = ko.pureComputed(() => nav.query.getSearch());
		debugInfo.setSearchCriteria(searchCriteria());
		searchCriteria.subscribe(val => {
			debugInfo.setSearchCriteria(val);
		});
	}

	_updateServerDataWhenReady(data) {
		if (this.ready()) {
			this._updateServerData(data);
		} else {
			logger.log('delay server data');
			this._whenReady(() => this._updateServerData(data));
		}
	}

	_updateServerData(data) {
		logger.log('init from data', data);
		if (data['meta']) {
			this._initMeta(data['meta']);
		}
		if (data['viewdata']) {
			this.pageData.update(data['viewdata']);
		}
		if (data['products']) {
			this._initProducts(data);
		}
	}

	_whenReady(callback) {
		const subscription = this.ready.subscribe(val => {
			if (val) {
				callback.call(this);
				subscription.dispose();
			}
		});
	}

	_initScrollTop() {
		this.viewOptions.onPageChanged(() => this._scrollTop());
		this.viewOptions.onLimitChanged(() => this._scrollTop());
	}

	_scrollTop() {
		logger.log('scroll to top');
		const top = $('#shopCatalog').offset().top;
		if ($(window).scrollTop() > top) {
			this.ready(false);
			$('html, body').stop().animate({scrollTop: top}, 500, () => {
				this.ready(true);
			});
		}
	}

	_initMeta(meta) {
		this.sidebar.init(meta);
		this.viewOptions.init(meta);
		if (meta['selection']) {
			this.selection.init(meta['selection']);
		}
	}

	_initProducts(data) {
		this.products.init({
			items: data['products'],
			favorites: data['favorites'],
			scores: data['productsScores']
		});
	}
}

class Sidebar {
	categories = new CategoryList();
	attributes = new Attributes();
	brands = new BrandList();
	shops = new ShopList();

	priceRangeFilter = new PriceRangeFilter();
	discountRangeFilter = new DiscountRangeFilter();
	lastUpdateFilter = new LastUpdateFilter();
	availabilityFilter = new AvailabilityFilter();
	discountFilter = new DiscountFilter();

	categoryList = ko.pureComputed(() => {
		const cat = this.selectedCategory;
		if (cat) {
			if (this.selectedSubcategory) {
				return null;
			}
			return cat.subcategories;
		}
		return this.categories;
	});

	/** @return {CategoryItem|null} */
	get selectedCategory() {
		return this.categories.getItemByName(nav.query.getCategory());
	}

	/** @return {SubcategoryItem|null} */
	get selectedSubcategory() {
		const cat = this.selectedCategory;
		return cat ? cat.subcategories.getItemByName(nav.query.getSubcategory()) : null;
	}

	constructor() {
		this.categories.onItemClick(item => {
			if (item instanceof SubcategoryItem) {
				nav.query.setSubcategory(item.category.name, item.name);
			} else if (item instanceof CategoryItem) {
				nav.query.setCategory(item.name);
			} else if (item instanceof PopularShopItem) {
				nav.query.setCategory(item.category.name);
				nav.query.setShop(item.id);
			}
		});

		this._isSearch = ko.pureComputed(() => {
		    return !!(nav.query.getSearch() || nav.query.getSearchResults());
		});
		/*this._isSearch.subscribe((isSearch) => {
			this.categories.sortByCount = isSearch;
		})*/
	}

	init(meta) {
		this.categories.sortType = this._isSearch() ? 'count' : null;

		if (meta['data']) {
			this.initData(meta['data']);
		}
		if (meta['counts']) {
			this._updateCounts(meta['counts']);
		}
		if (meta['priceRange']) {
			this.priceRangeFilter.update(meta['priceRange']);
		}
		if (meta['discountRange']) {
			this.discountRangeFilter.update(meta['discountRange']);
		}
		if (meta['lastUpdateRange']) {
			this.lastUpdateFilter.update(meta['lastUpdateRange']);
		}
		if (meta['availabilitySet']) {
			this.availabilityFilter.update(meta['availabilitySet']);
		}
		if (meta['discountSet']) {
			this.discountFilter.update(meta['discountSet']);
		}
		// logger.log('Brand counts:', _.keys(meta.brands).length);
		// logger.log('Shop counts:', _.keys(meta.shops).length);
	}

	initData(data) {
		if (data.categories) {
			this.categories.init(data.categories, data.categoryGroups);
		}
		if (data.brands) {
			this.brands.init(data.brands);
		}
		if (data.shops) {
			this.shops.init(data.shops);
		}
		if (data.attributes) {
			// init attributes only if any category is selected
			this.attributes.init(this._showAttributes ? data.attributes : []);
		}
	}

	_updateCounts(counts) {
		if (counts.categories) {
			this.categories.updateCounts(counts.categories);
		}
		if (counts.brands) {
			this.brands.updateCounts(counts.brands);
		}
		if (counts.shops) {
			this.shops.updateCounts(counts.shops);
		}
	}

	get _showAttributes() {
		return this.selectedCategory || this._isSearch();
	}
}

class ViewOptions {
	static defaults = {
		sort: '',
		limit: 60,
		page: 1,
		layout: 'tile'
	};

	sortBy = ko.pureComputed({
		read: () => nav.query.getSortBy(),
		write: (val) => nav.query.setSortBy(val)
	});
	limit = ko.pureComputed({
		read: () => nav.query.getLimit(),
		write: (val) => {
			const currLimit = this.limit();
			const newLimit = val;
			if (currLimit != newLimit) {
				logger.log('set limit', newLimit);
				const currPage = this.page();
				const newPage = Math.floor((currPage - 1)*currLimit/newLimit) + 1;
				nav.query.setLimit(newLimit, newPage);
				this._onLimitChanged.fire(this.limit());
			}
		}
	});
	page = ko.pureComputed({
		read: () => nav.query.getPage(),
		write: (val) => nav.query.setPage(val)
	});
	layout = ko.pureComputed({
		read: () => nav.query.getLayout(),
		write: (val) => nav.query.setLayout(val)
	});

	_totalCount = ko.observable(0).extend({numeric: 0});

	pagination = new Pagination();

	_onLimitChanged = $.Callbacks();

	constructor() {
		nav.query.setDefaults(ViewOptions.defaults);

		this.pagination.onPageChanged((page) => {
			this.page(page);
		});

		this.page.subscribe((val) => {
			this.pagination.currentPage(val);
		});
		this.limit.subscribe((val) => {
			this.pagination.perPageCount(val);
		});
	}

	init(meta) {
		this._totalCount(meta.totalCount);
		this.pagination.itemsCount(meta.totalCount);
		this.pagination.currentPage(this.page());
		this.pagination.perPageCount(this.limit());
	}

	setLayoutTile() {
		this.layout('tile');
	}

	setLayoutRow() {
		this.layout('row');
	}

	onPageChanged(callback) {
		this.pagination.onPageChanged(callback);
	}

	onLimitChanged(callback) {
		this._onLimitChanged.add(callback);
	}

	get totalCount() {
		return this._totalCount();
	}
}

class AdminPanel {
	_isVisible = ko.observable(false);

	/**
	 * @param {CProductList} productList
	 */
	constructor(productList) {
		this._productList = productList;

		this.toggleVisibleState = this.toggleVisibleState.bind(this);
	}

	toggleVisibleState() {
		this._isVisible(!this._isVisible());
	}

	get isVisible() {
		return this._isVisible();
	}

	selectAll() {
		this._productList.items.forEach(p => {
			p.isSelected = true;
		});
	}

	unselectAll() {
		this._productList.items.forEach(p => {
			p.isSelected = false;
		});
	}

	deleteItems() {
		const checkedItems = this._productList.checkedItems;
		if(checkedItems.length > 0) {
		    loading.show();
            $.post(urlUtils.siteUrl('shop/admin/deleteItems'), {ids: checkedItems.map(p => p.id)}, response => {
                loading.hide();
                if(response.success) {
                    Notifier.success('Товары удалены, изменения вступят в силу после индексирования');
                } else {
                	Notifier.error(response.error || null);
				}
            }, 'json');
        }
	}

	restoreItems() {
        const checkedItems = this._productList.checkedItems;
        if(checkedItems.length > 0) {
            loading.show();
            $.post(urlUtils.siteUrl('shop/admin/restoreItems'), {ids: checkedItems.map(p => p.id)}, response => {
                loading.hide();
                if(response.success) {
                	Notifier.success('Товары восстановлены, изменения вступят в силу после индексирования');
                } else {
                    Notifier.error(response.error || null);
                }
            }, 'json');
        }
	}

	changeCategory() {
        const checkedItems = this._productList.checkedItems;
        if(checkedItems.length > 0) {
            MODAL_SELECT_SHOP_CATEGORY.show(dialogResult => {
                if(dialogResult && dialogResult.categoryId) {
                    loading.show();
                    $.post(
                        urlUtils.siteUrl('shop/admin/changeCategory'),
                        {
                            ids: checkedItems.map(p => p.id),
                            category_id: dialogResult.categoryId
                        },
                        response => {
                            loading.hide();
                            if (response.success) {
                                Notifier.success('Товары добавлены в категорию, изменения вступят в силу после индексирования');
                            } else {
                                Notifier.error(response.error || null);
                            }
                        },
                        'json');
                }
            });
        } else {
        	Notifier.warning('Не выбрано ни одного товара');
		}
	}
}

class PageData {
	breadcrumbs = new Breadcrumbs();
	searchFilter = new SearchFilter();

	init() {
		this.breadcrumbs.init();
		this.searchFilter.init();
	}

	update(data) {
		if (data.title) {
			$('head title').html(data.title);
		}

		if (data.breadcrumbs) {
			this.breadcrumbs.update(data.breadcrumbs);
			this.searchFilter.updateSearchResultsInput();
		}
	}
}

class Breadcrumbs {
	$wrapper = $('#breadcrumbsWrapper');

	init() {
		this.$wrapper.on('click', '[itemprop=url]', function () {
			const href = $(this).attr('href');
			const parts = href.split('/');
			if(parts[parts.length - 1] === 'shop') {
				// Navigate to main page
				window.location = href;
			} else {
                nav.router.navigate(href, true);
			}
			return false;
		});
	}

	update(content) {
		if (content) {
			this.$wrapper.html(content);
		}
	}
}

class SearchFilter {
	$breadcrumbs = $('#breadcrumbsWrapper');
	$searchPanel = $('#searchPanel');

	init() {
		this.updateSearchResultsInput();

		// handle search forms
		/*this.$searchPanel.on('submit', '[rel=search-form]', (function (e) {
			e.preventDefault();
			const value = $.trim($(this).find('[rel=search-input]').val());
			nav.query.setSearch(value);
		}));*/
		this.$breadcrumbs.on('submit', '[rel=search-form]', (function (e) {
			e.preventDefault();
			const value = $.trim($(this).find('[rel=search-input]').val());
			nav.query.setSearchResults(value);
		}));

		// update search form
		ko.pureComputed(() => nav.query.getSearch()).subscribe(() => this.updateSearchInput());
		ko.pureComputed(() => nav.query.getSearchResults()).subscribe(() => this.updateSearchResultsInput());
	}

	updateSearchInput() {
		this.$searchPanel.find('[rel=search-form]')
			.find('[rel=search-input]')
			.val(nav.query.getSearch());
	}

	updateSearchResultsInput() {
		this.$breadcrumbs.find('[rel=search-form]')
			.find('[rel=search-input]')
			.val(nav.query.getSearchResults());
	}
}

class Pagination {
	// input parameters
	perPageCount = ko.observable(10);
	itemsCount = ko.observable(0);
	currentPage = ko.observable(1);
	size = ko.observable(3);

	// computed parameters
	pagesCount = ko.pureComputed(() => {
	    return Math.ceil(this.itemsCount()/this.perPageCount());
	});

	// events
	_onPageChanged = $.Callbacks();

	// output
	items = ko.pureComputed(() => {
		const pagesCount = this.pagesCount();
		if (pagesCount <= 0) {
			return [];
		}

		const currentPage = this.currentPage();
		const size = this.size();
		const total = size * 2;
		if (pagesCount <= total + 1) {
			return _.range(1, pagesCount + 1).map(i => {
				return new PaginationItem(i, i == currentPage);
			});
		}

		let first = Math.max(1, currentPage - size);
		let last = first + total;
		if (last > pagesCount) {
			last = pagesCount;
			first = last - total;
		}

		return _.range(first, last + 1).map(i => {
			return new PaginationItem(i, i == currentPage);
		});
	});
	firstItem = ko.pureComputed(() => {
		const item = _.first(this.items());
		return item && item.number > 1 ? new PaginationItem(1) : null;
	});
	lastItem = ko.pureComputed(() => {
		const item = _.last(this.items());
		const pagesCount = this.pagesCount();
		return item && item.number < pagesCount ? new PaginationItem(pagesCount) : null;
	});

	handleClickItem = (item) => {
		this._onPageChanged.fire(item.number);
	};

	onPageChanged(callback) {
		this._onPageChanged.add(callback);
	}
}

class PaginationItem {
	constructor(number, active) {
		this.number = number;
		this.active = active;
		this.url = nav.query.getPageUrl(number);
	}
}

/*
Filters
 */

class BaseFilterList extends List {
	_total = ko.observable(0);
	_isFetching = ko.observable();
	_filterSubscription = null;
	_isFiltered = ko.observable();
	_filterVisible = ko.observable(false);
	_initialData = ko.observable();
	_currentCriteria = ko.observable('');
	_limit = ko.observable(10);

	criteria = ko.observable('');

	constructor(data) {
		super(data);
		this._total(data ? data['total'] : 0);
		this._filterRequest = ko.pureComputed(this.criteria).extend({rateLimit: {timeout: 500, method: "notifyWhenChangesStop"}});
		this._filterSubscription = this._filterRequest.subscribe(query => {
			this._fetchItems(query);
		});
		this._visibleLimitedItems = ko.pureComputed(() => {
		    return _.first(this.visibleItems, this._limit());
		});
	}

	/**
	 * @return {number}
	 */
	get total() {
		return this._total() - this.selectedItems.length;
	}

	/**
	 * @return {boolean}
	 */
	get isFetching() {
		return this._isFetching();
	}

	/**
	 * @return {boolean}
	 */
	get isFiltered() {
		return this._isFiltered();
	}

	get isVisible() {
		return this.hasVisibleItems || this.total > 0 || this.isFilterVisible;
	}

	/**
	 * @return {boolean}
	 */
	get isFilterVisible() {
		return this._filterVisible();
	}

	get filterSource() {
		return super.unselectedItems;
	}

	/**
	 * @return {ListItem[]}
	 */
	get visibleLimitedItems() {
		return this._visibleLimitedItems();
	}

	/**
	 * @return {number}
	 */
	get moreCount() {
		return this.total - this.visibleLimitedItems.length;
	}

	/**
	 * @return {number}
	 */
	get visibleCount() {
		return this.visibleLimitedItems.length;
	}

	/**
	 * @return {number}
	 */
	get hiddenCount() {
		return this.visibleItems.length - this.visibleLimitedItems.length;
	}

	get sortItems() {
		return this.isFiltered ? false : super.sortItems;
	}

	filterPredicate(item) {
		return item.count > 0;
	}

	init(data) {
		this._filterVisible(null);
		super.init(data);
		this._initialData(data);
		this.criteria('');
		this._currentCriteria('');
		this._isFetching(false);
		this._isFiltered(false);
	}

	initData(data) {
		super.initData(data);
		if (!_.isUndefined(data['total'])) {
			this._total(data['total']);

			if (this._filterVisible() === null) {
				this._filterVisible(this.moreCount > 0);
			}
		}
	}

	initItems(itemsData) {
		// super.initItems(itemsData ? itemsData.slice(0, this.itemsLimit()) : []);
		super.initItems(itemsData);
		if (!this._total()) {
			this._total(this.items.length);
		}
	}

	showMore() {
		this._limit(this._limit() + 10);
	}

	resetFilter() {
		this._restoreItems();
	}

	_fetchItems(criteria) {
		criteria = $.trim(criteria);

		if (criteria == this._currentCriteria()) {
			return;
		}

		logger.log("query " + this.name + ": " + criteria);

		if (!criteria) {
			this._restoreItems();
			return;
		}

		const data = {
			action: 'filter',
			f_name: this.name,
			f_criteria: criteria
		};

		const query = nav.query.getQuery();

		const url = urlUtils.joinPath(settings.catalogApiUrl, {...query, ...data});

		logger.log(url);

		this._currentCriteria(criteria);
		this._isFetching(true);
		$.get(url, null, response => {
			logger.log("new data", response);
			this.initData(response);
			this._isFetching(false);
			this._isFiltered(true);
		}, 'json');
	}

	_restoreItems() {
		logger.log("Restore initial data");
		this.init(this._initialData());
	}
}

/*
Brands
 */

class BrandList extends BaseFilterList {
	constructor(data = null) {
		super({name: 'brand', title: lang('shop_filter_brand'), ...data});
	}

	newItem(itemData) {
		return new BrandItem(itemData);
	}

	handleClick(item) {
		nav.query.toggleBrand(item.id);
	}
}

class BrandItem extends ListItem {
	constructor(data) {
		super(data);
		this._selected = ko.pureComputed(() => {
			return nav.query.getBrands().indexOf("" + this.id) >= 0;
		});
	}

	get selected() {
		return this._selected();
	}
}

/*
Shops
 */

class ShopList extends BaseFilterList {
	constructor(data = null) {
		super({name: 'shop', title: lang('shop_filter_shop'), ...data});
	}

	newItem(itemData) {
		return new ShopItem(itemData);
	}

	handleClick(item) {
		nav.query.toggleShop(item.id);
	}
}

class ShopItem extends ListItem {
	constructor(data) {
		super(data);
		this._selected = ko.pureComputed(() => {
			return nav.query.getShops().indexOf("" + this.id) >= 0;
		});
	}

	get selected() {
		return this._selected();
	}
}

/*
Attributes
 */

class Attributes {
	_items = ko.observableArray([]).indexBy('id');

	init(data) {
		/** @var {AttrbuteList[]} */
		let items = _.map(data, itemData => {
			const list = new AttrbuteList(itemData);
			list.init(itemData);
			return list;
		});
		items = _.sortBy(items, list => list.order);
		this._items(items);
	}

	/**
	 * @return {AttrbuteList[]}
	 */
	get items() {
		return this._items();
	}
}

class AttrbuteList extends List {
	_type = null;
	_order = null;

	constructor(data = null) {
		super(data);
		this._type = data ? data.type : null;
		this._order = data ? data.order : null;
	}

	/**
	 * @return {number}
	 */
	get order() {
		return this._order;
	}

	initData(data) {
		super.initData(data);
		if (!_.isUndefined(data['type'])) {
			this._type = data['type'];
		}
		if (!_.isUndefined(data['order'])) {
			this._order = data['order'];
		}
	}

	newItem(itemData) {
		return new AttributeItem(itemData, this.name);
	}

	handleClick(item) {
		nav.query.toggleAttribute(this.name, item.id);
	}

	get filterSource() {
		return super.unselectedItems;
	}

	/**
	 * @param {AttributeItem} item1
	 * @param {AttributeItem} item2
	 * @return {number}
	 */
	sortFunction(item1, item2) {
		if (item2.order == item1.order) {
			return super.sortFunction(item1, item2);
		} else {
			return item1.order - item2.order;
		}
	}
}

class AttributeItem extends ListItem {
	constructor(data, listName) {
		super(data);
		this._order = data.order;
		this._listName = listName;
		this._selected = ko.pureComputed(() => {
			const index = nav.query.getAttributeValues(listName).indexOf("" + this.id);
			return index >= 0;
		});
	}

	get order() {
		return this._order;
	}

	get selected() {
		return this._selected();
	}

	get hint() {
		const formattedCount = numeral(this.count).format('0,0');
		const countText = langUtils.pluralize(this.count, lang('shop_products_plural'), 'n', formattedCount);
		if (this._listName == 'color') {
			return `${this.title} (${countText})`;
		} else {
			return countText;
		}
	}
}

/*
Selections
 */
class SelectionList {
	_itemsByType = ko.observable({});
	_items = ko.observable([]);

	constructor() {
		this._itemsByType = ko.pureComputed(() => {
			return _.groupBy(this._items(), item => item.type);
		});

		this.handleClick = this.handleClick.bind(this);
		this.reset = this.reset.bind(this);
	}

	get items() {
		return this._items();
	}

	get isEmpty() {
		return this._items().length == 0;
	}

	getItemsOfType(type) {
		return this._itemsByType()[type] || [];
	}

	hasItemsOfType(type) {
		return this.getItemsOfType(type).length > 0;
	}

	init(data) {
		const items = _.map(data, d => this._newItem(d));
		this._items(items);
	}

	/**
	 * @param {SelectionItem} item
	 */
	handleClick(item) {
		item.deselect();
		this._removeItem(item);
	}

	reset() {
		[...this.items].forEach(item => {
			this.handleClick(item);
		});
	}

	_newItem(itemData) {
		switch (itemData.type) {
			case 'search':
				return new SearchSelectionItem(itemData);
			case 'search_results':
				return new SearchResultsSelectionItem(itemData);
			case 'price':
				return new PriceSelectionItem(itemData);
		}
		return new SelectionItem(itemData);
	}

	_removeItem(item) {
		const items = this._items();
		const i = _.indexOf(items, item);
		if (i >= 0) {
			items.splice(i, 1);
		}
		this._items(items);
	}
}

class SelectionItem {
	constructor(data) {
		this._type = data ? data.type : null;
		this._id = data ? data.id : null;
		this._title = data ? data.title : null;
	}

	get type() {
		return this._type;
	}

	get id() {
		return this._id;
	}

	get title() {
		return this._title;
	}

	deselect() {
		nav.query.toggleValue(this.type, this.id);
	}
}

class SearchSelectionItem extends SelectionItem {
	deselect() {
		nav.query.setSearch(null);
	}
}

class SearchResultsSelectionItem extends SelectionItem {
	deselect() {
		nav.query.setSearchResults(null);
	}
}

class PriceSelectionItem extends SelectionItem {
	constructor(data) {
		super(data);
		this._min = data ? settings.convertPrice(data.min) : null;
		this._max = data ? settings.convertPrice(data.max) : null;
	}

	get title() {
		if (this._min && this._max) {
			return numeral(this._min).format('0,0') + ' - ' + numeral(this._max).format('0,0 $');
		} else if (this._min) {
			return lang('shop_filter_price_from', {price: numeral(this._min).format('0,0 $')});
		} else if (this._max) {
			return lang('shop_filter_price_to', {price: numeral(this._max).format('0,0 $')});
		} else {
			return '';
		}
	}

	deselect() {
		nav.query.setMinPrice(null);
		nav.query.setMaxPrice(null);
	}
}

/*
Price and discount
 */

class RangeFilter {
	min = ko.observable(0);
	max = ko.observable(0);

	from = ko.pureComputed({
		read: () => nav.query.getQueryParam(this._minParamName),
		write: (val) => nav.query.setQueryParam(this._minParamName, val)
	});
	to = ko.pureComputed({
		read: () => nav.query.getQueryParam(this._maxParamName),
		write: (val) => nav.query.setQueryParam(this._maxParamName, val)
	});

	rangeSliderData = ko.pureComputed(() => {
		const min = this.min();
		const max = this.max();
		const from = this.from();
		const to = this.to();
		const step = 1;//Math.round((max-min)*0.01);
		return {min, max, from, to, step};
	});

	/**
	 * @param {string} paramName Query parameter name. Will be prefixed with 'min_' and 'max_'
	 * @param {string} type Slider type. 'integer' or 'double'
	 */
	constructor(paramName, type) {
		this._minParamName = 'min_' + paramName;
		this._maxParamName = 'max_' + paramName;
		this._type = type;
	}

	update(data) {
		const min = Math.floor(data.min);
		const max = Math.ceil(data.max);

		nav.query.setDefaults({
			[this._minParamName]: min,
			[this._maxParamName]: max
		});

		this.min(min);
		this.max(max);
	}

	get rangeSliderOptions() {
		return {
			type: this._type,
			min_interval: 1,
			force_edges: true,
			onFinish: data => {
				this.from(data.from);
				this.to(data.to);
			}
		};
	}

	get isVisible() {
		return this.max() > this.min();
	}

	get isSelected() {
		return this.from() > this.min() || this.to() < this.max();
	}

	reset() {
		this.from(this.min());
		this.to(this.max());
	}
}

class PriceRangeFilter extends RangeFilter {
	constructor() {
		super('price', 'double');
	}

	get rangeSliderOptions() {
		return {
			...super.rangeSliderOptions,
			prettify_enabled: true,
			prettify: value => {
				return numeral(settings.convertPrice(value)).format('0,0');
			},
		};
	}
}

class DiscountRangeFilter extends RangeFilter {
	constructor() {
		super('discount', 'integer');
	}
}

/*
Other filters
 */


class BaseOptionFilter {
	value = ko.pureComputed({
		read: () => {
			const val = nav.query.getQueryParam(this._name);
			return val !== '' ? val : undefined;
		},
		write: (val) => {
			nav.query.setQueryParam(this._name, val !== undefined ? val : '');
		}
	});

	_visibleKeys = ko.observable();

	constructor(name, defaultValue = '') {
		this._name = name;

		nav.query.setDefaults({
			[name]: defaultValue,
		});

		this._visibleOptions = ko.pureComputed(() => {
			/** @type string[] */
			const visibleKeys = this.visibleKeys;
			if (visibleKeys) {
		    	return _.filter(this.options, o => visibleKeys.indexOf(o.key) >= 0);
		    } else {
				return this.options;
			}
		});
	}

	get name() {
		return this._name;
	}

	get options() {
		return [];
	}

	get visibleKeys() {
		return this._visibleKeys();
	}

	get visibleOptions() {
		return this._visibleOptions();
	}

	get caption() {
		return lang('shop_filter_not_selected');
	}

	update(data) {
		this._visibleKeys(data.keys);
	}
}

class LastUpdateFilter extends BaseOptionFilter {
	constructor() {
		super('last_update');
	}

	get options() {
		return [
			{key: '336', title: lang('shop_filter_last_update_option_2_weeks')},
			{key: '168', title: lang('shop_filter_last_update_option_1_week')},
			{key: '72', title: lang('shop_filter_last_update_option_3_days')},
			{key: '24', title: lang('shop_filter_last_update_option_1_day')},
		];
	}

	update(data) {
		const now = new Date().getTime();
		const items = _.filter(this.options, o => {
			const itemHours = now - o.key*60*60*1000;
			return itemHours <= data.max;
		});
		const keys = _.map(items, item => item.key);
		super.update({keys});
	}
}

class AvailabilityFilter extends BaseOptionFilter {
	constructor() {
		super('availability');
	}

	get options() {
		return [
			{key: 'yes', title: lang('shop_filter_availability_option_yes')},
			{key: 'likely', title: lang('shop_filter_availability_option_likely')},
		];
	}
}

class DiscountFilter extends BaseOptionFilter {
	constructor() {
		super('discount');
	}

	get options() {
		return [
			{key: 'yes', title: lang('shop_filter_discount_option_yes')},
			{key: 'no', title: lang('shop_filter_discount_option_no')},
		];
	}

	/*update(data) {
		const keys = [];
		if (data.min == 0) {
			keys.push("no");
		}
		if (data.max > 0) {
			keys.push("yes");
		}
		super.update({keys});
	}*/
}

/*
Products
 */

class CProductList extends ProductList {
	/**
	 * @param {Settings} settings
	 * @param {Sidebar} sidebar
	 */
	constructor(settings, sidebar) {
		super(settings);
		this._sidebar = sidebar;

		this._selectedProducts = ko.pureComputed(() => {
		    return this.items.filter(p => p.isSelected);
		});
	}

	newItem(itemData) {
		if (itemData['brandId']) {
			itemData['brand'] = this._sidebar.brands.getItem(itemData['brandId']);
		}
		if (itemData['subcategoryId']) {
			itemData['subcategory'] = this._sidebar.categories.getAnyItem(itemData['subcategoryId']);
		}
		return new CProductItem(itemData, this.settings);
	}

	/** @return {CProductItem[]} */
	get items() {
		return super.items;
	}

    /** @return {CProductItem[]} */
	get checkedItems() {
		return super.items.filter(p => p.isSelected);
	}

	__init(data) {
		if (settings.isAdmin && !_.isEmpty(data['scores'])) {
			data['items'].forEach(item => {
				item['score'] = data['scores'][item['id']];
			});
		}

		super.init(data);
	}
}

class CProductItem extends ProductItem {
	_isSelected = ko.observable(false);

	/**
	 * @param {object} data
	 * @param {Settings} settings
	 */
	constructor(data, settings) {
		super(data, settings);
		this.brand = data.brand;
		this.subcategory = data.subcategory;
		if (!settings.useOfferUrl) {
			this._setUrl(data);
		}
		this.score = data.score;
	}

	get isCheckboxVisible() {
		return settings.isAdmin;
	}

	get isFavoritesVisible() {
		return settings.useFavorites;
	}

	get isSelected() {
		return this._isSelected();
	}

	set isSelected(value) {
		this._isSelected(!!value);
	}

	toggleSelectState() {
		this._isSelected(!this._isSelected());
	}

	toggleFavorite() {
		const state = this._favorite();
		this._favorite(!state);
		const url = state ? 'favorites/removeProduct/' : 'favorites/addProduct/';
		$.post(urlUtils.siteUrl(url + this.id)).done(() => {
			if (state) {
				Notifier.info('Товар удален из избранного');
			} else {
				Notifier.info('Товар добавлен в избранное');
			}
		}).fail(() => {
			// revert visual state
			this._favorite(state);
			Notifier.error('Ошибка при добавлении в избранное');
		});
	}

	_setUrl(data) {
		const category = nav.query.getCategory();
		const subcategory = nav.query.getSubcategory();
		const search = nav.query.getSearch();
		const search_results = nav.query.getSearchResults();

		// override product url according to user navigation in catalog
		if (category || subcategory) {
			this.url = urlUtils.joinPath(
				settings.shopUrl,
				category,
				subcategory,
				data.name
			);
		}
		if (search || search_results) {
			this.url = urlUtils.joinPath(
				this.url,
				search ? {search} : null,
				search_results ? {search_results} : null,
			);
		}
	}
}

ko.components.register('shop-catalog', {
	viewModel: {
		createViewModel: function (params) {
			return params.model;
		}
	},
	template: require('./templates/catalog.html')
});

ko.components.register('catalog-sidebar', {
	viewModel: {
		createViewModel: function (params) {
			return params.sidebar;
		}
	},
	template: require('./templates/sidebar.html')
});

ko.components.register('filter-block', {
	viewModel: function (params) {
		this.title = params.title;
		this.data = params.data;
	},
	template: require('./templates/filters/filter-block.html')
});

ko.components.register('list-filter', {
	viewModel: function (params) {
		this.list = params.list;
	},
	template: require('./templates/filters/list-filter.html')
});

ko.components.register('attribute-filter', {
	viewModel: function (params) {
		this.list = params.list;
	},
	template: require('./templates/filters/attribute-filter.html')
});

ko.components.register('category-filter', {
	viewModel: function (params) {
		this.list = params.list;
	},
	template: require('./templates/filters/category-filter.html')
});

ko.components.register('dropdown-filter', {
	viewModel: function (params) {
		this.filter = params.filter;
	},
	template: require('./templates/filters/dropdown-filter.html')
});

ko.components.register('range-filter', {
	viewModel: function (params) {
		this.filter = params.filter;
	},
	template: require('./templates/filters/range-filter.html')
});

ko.components.register('selection-items', {
	viewModel: function (params) {
		/** @type {SelectionList} */
		const model = params.model;
		this.selection = params.model;
		this.type = params.type;
		this.items = ko.computed(() => {
		    return params.type ? model.getItemsOfType(ko.unwrap(params.type)) : model.items;
		});
		this.showReset = element(params, 'showReset', false);
	},
	template: require('./templates/filters/selection-items.html')
});

ko.components.register('catalog-title', {
	viewModel: {
		createViewModel: function (params) {
			return params.model;
		}
	},
	template: require('./templates/title.html')
});

ko.components.register('active-filters', {
	viewModel: {
		createViewModel: function (params) {
			return params.model;
		}
	},
	template: require('./templates/active-filters.html')
});

ko.components.register('view-options', {
	viewModel: function (params) {
		/** @type {ViewOptions} */
		this.model = params.model;
		this.sortTypes = [
			{key: '', title: lang('shop_sorting_option_default')},
			{key: 'date', title: lang('shop_sorting_option_date')},
			{key: 'discount', title: lang('shop_sorting_option_discount')},
			{key: 'price_asc', title: lang('shop_sorting_option_price_asc')},
			{key: 'price_desc', title: lang('shop_sorting_option_price_desc')},
		];
		this.limitValues = [30, 60, 90];

		this.showCountInfo = element(params, 'showCountInfo', true);
		this.showPageInfo = element(params, 'showPageInfo', true);
		this.showPagination = element(params, 'showPagination', false);
		this.showSorting = element(params, 'showSorting', true);
		this.showLimit = element(params, 'showLimit', true);

		this.productsPluralText = ko.pureComputed(() => {
			const count = this.model.totalCount;
			const formattedCount = numeral(count).format('0,0');
		    return langUtils.pluralize(count, lang('shop_products_plural'), 'n', formattedCount);
		});
	},
	template: require('./templates/view-options.html')
});

ko.components.register('admin-panel', {
	viewModel: {
		createViewModel: function (params) {
			return params.model;
		}
	},
	template: require('./templates/admin-panel.html')
});

ko.components.register('product-list', {
	viewModel: function (params) {
		this.list = params.list;
	},
	template: require('./templates/product-list.html')
});

ko.components.register('product-list-item', {
	viewModel: {
		createViewModel: function (params) {
			return params.product;
		}
	},
	template: require('./templates/product-list-item.html')
});

import '../common/components';



// WEBPACK FOOTER //
// ./modules/shop/catalog/viewmodel.js